'use client';
import React from 'react';
import SideNavItem, {
	SideNavItemProps,
} from '../../components/SideNavItem/SideNavItem';
import { icons } from '@/Icons';
import { ModalStatusEnum, useModalStoreActions } from '@/store';
import SectionTitle from '../../components/SectionTitle/SectionTitle';
import { SectionWrapper } from '../../SideNav';

const ProfileLinks = () => {
	const { setModalStatus } = useModalStoreActions();

	const profileData: SideNavItemProps[] = [
		{
			title: 'Wallet',
			link: '/account?type=wallet',
			icon: <icons.wallet />,
			onClick: () => {
				setModalStatus(ModalStatusEnum.WalletModal);
			},
			authRequired: true,
		},
		{
			title: 'Transactions',
			link: '/account?type=transactions',
			icon: <icons.transactions />,
			authRequired: true,
		},
		{
			title: 'Settings',
			link: '/account?type=profile',
			icon: <icons.settings />,
			authRequired: true,
		},
	];

	return (
		<SectionWrapper>
			<SectionTitle title="Profile" />

			{profileData.map((item, index) => {
				return <SideNavItem key={index} {...item} />;
			})}
		</SectionWrapper>
	);
};

export default ProfileLinks;
